import Vue from "vue";
import VueRouter from "vue-router";
import { createRouter, createWebHistory } from "vue-router";
import store from '@/state/store';
import HttpRequest from "@/state/http_request";
import NProgress from "nprogress/nprogress";
import routes from "./routes";
import axios from "axios";
import { setUser, setParent, setWallet, setPermission, getPermission } from "@/plugins/userData";

const HttpRequestService = new HttpRequest();

Vue.use(VueRouter);

const router = createRouter({
    routes,
    history: createWebHistory(),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
});

function updateUserData(userData) {
    try {
        // วิธีเก่า
        const token = localStorage.getItem("token");
        localStorage.setItem("auth.currentUser", JSON.stringify({
            access_token: token,
            user: {
                name: userData?.name,
                profile_pic: userData?.profile_pic,
                nameShop: userData?.name,
                account_child_link: userData?.account_child_link,
                access_level: userData?.account_child_link?.access_level?.id,
                access_level_detail: userData?.account_child_link?.access_lv,
                card_verify_flag: userData?.card_verify_flag,
                juristic_verify_flag: userData?.juristic_verify_flag,
                request_support_flag: userData?.request_support_flag,
                cod_bank_verify_flag: userData?.cod_bank_verify_flag,
                cod_amount: userData?.wallet?.cod_wallet_amount,
                credit: userData?.wallet?.credit_amount,
                id: userData,
            }
        }));

        HttpRequestService.setHeader({
            key: "Authorization",
            value: `Bearer ${token}`,
        });

        // วิธีใหม่
        setUser(userData.account_child_link?.child_account);
        setParent(userData);
        setWallet(userData);
        setPermission(userData?.account_child_link?.access_level);

        return true;
    } catch (error) {
        console.error("Error updating user data:", error);
        return false;
    }
}

async function init() {
    try {
        const response = await store.dispatch('api/getInit');

        if (!response.error) {
            updateUserData(response.data);
        } else {
            throw new Error(response.error);
        }

    } catch (error) {
        console.error("Error fetching user data:", error);
    }
}

// Navigation Guard หลัก
router.beforeEach(async (routeTo, routeFrom, next) => {
    // logic logout และเคลียร์ข้อมูลทั้งหมด
    if (routeTo.path == '/user/logout') {
        localStorage.removeItem("auth.currentUser");
        localStorage.removeItem("vuex");

        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("parent");
        localStorage.removeItem("wallet");
        localStorage.removeItem("permission");

        return next({ path: "/login" });
    }

    // กรณี push query string มา จะข้ามการตรวจสอบระบบ
    if (routeTo.path === routeFrom.path) {
        return next();
    }

    // ตรวจสอบ version
    let version;

    try {
        version = await axios(`${window.location.protocol}//${window.location.host}/version.json`);
    } catch (error) {
        console.error("Error fetching version:", error);
        version = { status: false };
    }

    if (version.status && version.data?.version) {
        let oldVersion = localStorage.getItem("version");
        // version ไม่ตรงกัน จะบังคับรีเฟรชหน้า
        if (oldVersion != version.data.version) {
            localStorage.setItem("version", version.data.version);

            await new Promise((resolve) =>
                setTimeout(() => {
                    const targetPath = routeTo.fullPath;
                    const separator = targetPath.includes('?') ? '&' : '?';
                    location.replace(targetPath + separator + 'v=' + Date.now());
                    resolve();
                }, 300)
            );
        }
    }

    store.commit("auth/SET_STATUS_TAB", false);

    // เริ่ม progress bar
    if (routeFrom.name !== null) {
        NProgress.start();
    }

    // หน้า login, register, forgot
    if (["login", "register", "forgot-password"].includes(routeTo.name)) {
        // ถ้ามี token ให้ init ว่าใช้งานได้หรือเปล่า
        if (localStorage.getItem("token")) {
            await init();
            return next({ path: routeTo.query.redirect || "/" });
        }
    // หน้า login-key, register-key
    } else if (["login-key", "register-key"].includes(routeTo.name)) {
        // ถ้ามี token ให้ init ว่าใช้งานได้หรือเปล่า
        if (localStorage.getItem("token")) {
            await init();
            return next({ path: "/invite/" + routeTo.params.invite_key });
        }
    }

    // ตรวจสอบว่าเป็นหน้าที่ต้องการ auth หรือไม่
    if (!routeTo.meta.authRequired) {
        next();

    } else {
        // เก็บหน้าที่กำลังจะไปลงไว้ เผื่อหลุดจากระบบเพราะ init ไม่ได้
        if (!["home", "user-switch-account", "invite-key"].includes(routeTo.name)) {
            localStorage.setItem("redirectPath", routeTo.path);
        }

        // อัพเดทข้อมูลใหม่ทุกครั้ง
        await init();
        const permission = getPermission();

        if (routeTo.meta.type == "default" || permission?.[routeTo.meta.type] == 1) {
            // ไม่ต้องการสิทธิ์ หรือ มีสิทธิ์เข้าถึง
            next();

        } else {
            // ไม่มีสิทธิ์เข้าถึง
            next({ path: "/" });
        }
    }

});

// เมื่อ resolve เส้นทางเสร็จสิ้น
router.beforeResolve(async (routeTo, routeFrom, next) => {
    next();
});

// เมื่อนำทางเสร็จสิ้น
router.afterEach(() => {
    // หยุด progress bar
    NProgress.done();
});

export default router;
